<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="contents"></a><a id="page_v"></a><em>Contents</em></h2>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr><td valign="top"><p class="tocfront"><a class="nounder" href="#/xhtml/acknowledgements#acknowledgements"><span class="small">EDITOR’S NOTE AND ACKNOWLEDGMENTS</span></a></p></td></tr>
<tr><td valign="top"><p class="tocfront"><a class="nounder" href="#/xhtml/forward#forward"><span class="small">FOREWORD BY RICK ATKINSON</span></a></p></td></tr>
<tr><td valign="top"><p class="tocsec1"><a class="nounder" href="#/xhtml/introduction#introduction">Introduction</a></p></td></tr>
<tr><td valign="top"><p class="tocchap"><a class="nounder" href="#/xhtml/chapter01#ch01"><strong>Part 1</strong><br/>From Manhattan to Cairo, September–October 1942</a></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/chapter02#ch02" title="Link target outside of Sample"><strong>Part 2</strong><br/>Cairo Journal, October–November 1942</span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/chapter03#ch03" title="Link target outside of Sample"><strong>Part 3</strong><br/>In Pursuit of Rommel (Libya), November 1942–February 1943</span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/chapter04#ch04" title="Link target outside of Sample"><strong>Part 4</strong><br/>Victory in Tunisia, March–April 1943</span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/chapter05#ch05" title="Link target outside of Sample"><strong>Part 5</strong><br/>Sicily, July–August 1943</span></p></td></tr>
<tr><td valign="top"><p class="tocsec1"><span class="nounder" href="#/xhtml/afterword#afterword" title="Link target outside of Sample"><span class="small">AFTERWORD</span><br/>Command Sergeant Major Ben Franklin</span></p></td></tr>
<tr><td valign="top"><p class="tocsec2"><span class="nounder" href="#/xhtml/appendix#appendix" title="Link target outside of Sample"><span class="small">APPENDIX</span></span></p></td></tr>
<tr><td valign="top"><p class="tocback"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><span class="small">NOTES</span></span></p></td></tr>
<tr><td valign="top"><p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><span class="small">INDEX</span></span></p></td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?1b629d1a